import React from 'react';
import cx from 'classnames';
import Spinner from '../Spinner/Spinner';
import './Loading.scss';

const Loading = ({ className, wrapperClassName, fullContainer, children }) => {
  return (
    <div
      className={cx('loading-center', {
        'loading-center-full-container': fullContainer,
        [wrapperClassName]: !!wrapperClassName,
      })}
    >
      <div>{children ? children : <Spinner className={className} />}</div>
    </div>
  );
};

export default Loading;
